module.exports = __webpack_public_path__ + "static/img/surAlready.856b5d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surAlready.png
// module id = zzKX
// module chunks = 1